import { CoursesTab } from "@/components/admin/CoursesTab";

export function SettingsCoursesPage() {
  return <CoursesTab />;
}
